import { Map } from 'immutable';

const defaultPipeState = Map({
  ownerView: '',
  reading: Map(),
  writing: Map(),
});

export default defaultPipeState;
